export const BtnAtras = ({ titulo }) => {
  return (
    <div className="container-btn-titulo">
      <h1 className="titulos">{titulo}</h1>
    </div>
  );
};
